<template>
<div class="navbar navbar-expand-md navbar-dark">
    <div class="navbar-brand">
        <router-link to="/" class="d-inline-block">
            <img alt="" :src="require('@/assets/images/logo.png')" />
        </router-link>
    </div>

    <div class="d-md-none">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar-mobile">
            <i class="icon-tree5"></i>
        </button>
        <button class="navbar-toggler sidebar-mobile-main-toggle" type="button">
            <i class="icon-paragraph-justify3"></i>
        </button>
    </div>

    <div class="collapse navbar-collapse justify-content-between" id="navbar-mobile">
        <ul class="navbar-nav">
            <li class="nav-item">
                <a href="javascript:void(0);" class="
              navbar-nav-link
              sidebar-control sidebar-main-toggle
              d-none d-md-block
            ">
                    <i class="icon-paragraph-justify3"></i>
                </a>
            </li>
        </ul>
        
        <Navbar />
    </div>
</div>
</template>

<script>
import {
    localSave,
    localRead
} from "@/store/lang";
import Navbar from './Navbar.vue'

export default {
    name: "TopMenu",
    data() {
        return {
            lang: localRead("local"),
            tenantName: '',
            user: {
                name: '',
                role: 'Administer'
            },
            localList: {
                th: "Thai",
                en: "English",
            },
        };
    },
    components: {
        Navbar
    },

    computed: {
        title() {
            return this.localList[this.lang];
        },
    },
    methods: {
        selectLang(lang) {
            localSave("local", lang);
            location.reload();
        },
    },

};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/layouts/web/admin/TopMenu.vue